import { configureStore } from '@reduxjs/toolkit';
import { StateLoader } from "./stateLoader";
import favoritosReducer from './favoritos/favoritosSlice';
import leadReducer from './lead/leadSlice';
import carritoReducer from './carrito/carritoSlice';
import carritoMayoristaReducer from './carritoMayorista/carritoMayoristaSlice';
import userReducer from './user/userSlice';
import cpReducer from './cp/cpSlice';
import uiReducer from './ui/uiSlice';

const stateLoader = new StateLoader();

export const store = configureStore({
  reducer: {
    favoritos: favoritosReducer,
    lead: leadReducer,
    carrito: carritoReducer,
    carritoMayorista: carritoMayoristaReducer,
    user: userReducer,
    cp: cpReducer,
    ui: uiReducer,
  },
  preloadedState: stateLoader.loadState(),
  devTools: process.env.NEXT_PUBLIC_ENVIRONMENT === "dev"
});

store.subscribe(() => {
  // console.log("State: ", store.getState());
  stateLoader.saveState(store.getState());
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
